const _throttle = require('lodash.throttle');
const _debounce = require('lodash.debounce');

window.addEventListener('load', () => {
    const progressCircle = document.querySelector('svg[data-progress-ring] > circle');
    const headerPanel = document.querySelector('.header-panel');
    if (progressCircle && headerPanel) {
        let elementToTrack = headerPanel;
        const originalElementToTrack = elementToTrack; // Store the original element
        const buttonWrapper = progressCircle.closest('button');

        if (elementToTrack) {
            const radius = progressCircle.r.baseVal.value;
            const circumference = 2 * Math.PI * radius;

            progressCircle.style.strokeDasharray = `${circumference} ${circumference}`;
            progressCircle.style.strokeDashoffset = circumference;

            let startScrollPosition = elementToTrack.offsetTop; // Initial start position
            let previousDocHeight = document.documentElement.scrollHeight; // Store initial document height

            const setProgress = (percent) => {
                const offset = circumference - (percent / 100) * circumference;
                progressCircle.style.strokeDashoffset = offset;
            };

            let elementIntersected = false;
            let observer = null;

            const createObserver = () => {
                if (observer) {
                    observer.disconnect(); // Disconnect the previous observer
                }

                observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) {
                            elementIntersected = true;
                            buttonWrapper.dataset.active = 'true';
                        } else {
                            elementIntersected = false;
                            buttonWrapper.dataset.active = 'false';
                        }
                    });
                });

                observer.observe(elementToTrack);
            };

            const updateElementToTrack = () => {
                const closestDiv = elementToTrack.closest('div[data-show-form-index]');
                if (closestDiv && closestDiv.dataset.showFormIndex !== '0') {
                    elementToTrack = closestDiv.querySelector('form');
                    startScrollPosition = elementToTrack.offsetTop;
                    createObserver(); // Recreate the observer for the new element
                } else {
                    elementToTrack = originalElementToTrack;
                    startScrollPosition = elementToTrack.offsetTop;
                    createObserver(); // Recreate the observer for the original element
                }
            };

            const handleScroll = _throttle(() => {
                if (elementIntersected) {
                    const scrollTop = window.scrollY;
                    const docHeight = document.documentElement.scrollHeight - window.innerHeight;

                    const scrollPercent = ((scrollTop - startScrollPosition) / (docHeight - startScrollPosition)) * 100;
                    const boundedScrollPercent = Math.min(Math.max(scrollPercent, 0), 100);
                    setProgress(boundedScrollPercent);
                }
            }, 50); // Throttle scroll event

            const handleResize = _debounce(() => {
                updateElementToTrack(); // Update elementToTrack on resize
                handleScroll(); // Recalculate progress after resize
            }, 100); // Debounce resize event

            createObserver(); // Initialize the observer

            window.addEventListener('scroll', handleScroll);
            window.addEventListener('resize', handleResize);

            buttonWrapper.addEventListener('click', () => {
                elementToTrack.closest('body').scrollIntoView({ behavior: 'smooth' });
            });

            handleScroll();

            setInterval(() => {
                const currentDocHeight = document.documentElement.scrollHeight;
                if (currentDocHeight !== previousDocHeight) {
                    previousDocHeight = currentDocHeight;
                    handleResize(); // Recalculate positions and progress
                }
            }, 500); // Check every 500ms
        }
    }
});
